import { standardRequest } from 'shared/utils/request';
import type { Dispatch, State } from '../use_candidate_profile';

export const markNotesAsRead =
  (state: State, dispatch: Dispatch) => async () => {
    const {
      paths: { updateLastSeenNotePath },
    } = state;

    await standardRequest.post(updateLastSeenNotePath);
    dispatch({ type: 'updateUnreadNotesCount', payload: { count: 0 } });
  };

type GetUnreadNotesCountAction = {
  type: 'updateUnreadNotesCount';
  payload: {
    count: number;
  };
};

export type Actions = GetUnreadNotesCountAction;
